export const ROLE_LABELS = {
    '1': 'Admin Pei',
    '2': 'Vendedor Pei',
    '3': 'Admin Trim',
    '4': 'Vendedor Trim',
    null: 'Cliente',
};

export const ROLE_DESCRIPTIONS = {
    '1': 'Acceso total a la plataforma Pei: gestiona usuarios, parámetros, valores residuales y todas las cotizaciones.',
    '2': 'Crea y administra cotizaciones de la plataforma Pei dentro de su equipo.',
    '3': 'Administra vendedores Trim asignados, supervisa sus cotizaciones y permisos.',
    '4': 'Crea cotizaciones bajo la supervisión de un Admin Trim.',
    null: 'Cliente final que recibió una cotización.',
};

export const ROLE_OPTIONS = [
    { value: '1', label: 'Admin Pei' },
    { value: '2', label: 'Vendedor Pei' },
    { value: '3', label: 'Admin Trim' },
    { value: '4', label: 'Vendedor Trim' },
];

export const ALLOWED_TRANSITIONS = {
    '1': ['2'],
    '2': ['1'],
    '3': ['4'],
    '4': ['3'],
};

export const labelOf = (typeUser) => ROLE_LABELS[typeUser ?? 'null'] ?? ROLE_LABELS.null;

export const initialsOf = (name) => {
    if (!name) return '·';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '·';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

export const formatDate = (iso) => {
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
        return '—';
    }
};

export const formatDateTime = (iso) => {
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        const date = d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
        const time = d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
        return `${date} · ${time}`;
    } catch {
        return '—';
    }
};

export const TAB_FILTERS = [
    { key: 'all',     label: 'Todos',           role: null },
    { key: 'pei_a',   label: 'Admin Pei',       role: '1' },
    { key: 'pei_v',   label: 'Vendedor Pei',    role: '2' },
    { key: 'trim_a',  label: 'Admin Trim',      role: '3' },
    { key: 'trim_v',  label: 'Vendedor Trim',   role: '4' },
    { key: 'clients', label: 'Clientes',        role: 'null' },
];

// KPI chips para Admin Pei: una sola fila que filtra por rol.
// Cada chip declara el conteo (key del meta.kpis) y el filtro a aplicar.
export const ROLE_KPI_DEFS = [
    { key: 'total',         label: 'Todos',          role: null,   tone: 'all',        icon: 'pi pi-users' },
    { key: 'admin_pei',     label: 'Admin Pei',      role: '1',    tone: 'pei_admin',  icon: 'pi pi-shield' },
    { key: 'vendedor_pei',  label: 'Vendedor Pei',   role: '2',    tone: 'pei_vend',   icon: 'pi pi-user' },
    { key: 'admin_trim',    label: 'Admin Trim',     role: '3',    tone: 'trim_admin', icon: 'pi pi-shield' },
    { key: 'vendedor_trim', label: 'Vendedor Trim',  role: '4',    tone: 'trim_vend',  icon: 'pi pi-user' },
    { key: 'clients',        label: 'Clientes',           role: 'null', tone: 'clients',  icon: 'pi pi-users' },
];

// KPI chips para Admin Trim: filtran por estado / fecha de alta.
// `param` describe qué query string mandar al endpoint /users.
export const TRIM_STATE_KPI_DEFS = [
    { key: 'total',    label: 'Total',              tone: 'all',       icon: 'pi pi-users',       param: { kind: 'reset' } },
    { key: 'active',   label: 'Activos',            tone: 'approved',  icon: 'pi pi-check-circle',param: { kind: 'active', value: 1 } },
    { key: 'inactive', label: 'Inactivos',          tone: 'cancelled', icon: 'pi pi-ban',         param: { kind: 'active', value: 0 } },
    { key: 'new_week', label: 'Nuevos esta semana', tone: 'progress',  icon: 'pi pi-user-plus',   param: { kind: 'new_week' } },
];
